import React from 'react';


export class LabeledSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            color: 'main',
            label: '',
            values: {},
            value: null,
            required: false,
            onChange: (event) => {},
            ...this.props
        };
    }

    renderOptions = () => {
        let options = [];

        const labels = Object.values(this.state.values);
        const values = Object.keys(this.state.values);

        if (!this.state.required) {
            options.push(<option key={-1}>&nbsp;</option>);
        }

        values.forEach(function(value, x) {
            options.push(<option value={value} key={x}>{labels[x]}</option>);
        });

        return options;
    }

    render() {
        return (
            <label className="imd-form-label">
                <span className="imd-text-light-gray">{this.state.label}</span>
                <select
                    className={'imd-form-control imd-text-' + this.state.color}
                    value={this.state.value}
                    onChange={(event) => this.state.onChange(event)}
                >
                    {this.renderOptions()}
                </select>
            </label>
        );
    }
}
